// @flow
import { _get } from "./methods";

export default {
  dashboard: (params: any) => _get("/admin/ai_meetups/dashboard", params)
};
